import React from 'react';
import PropTypes from 'prop-types';
import OtherImageryVendor from "./OtherImageryVendor";

function OtherImageryEvents({
  activeSubLayerId,
  collapsePanel,
  handleSelectEvent,
  layers,
  locale,
  vendors,
}) {
  const onSelectEvent = (provider, layer, index) => () => {
    handleSelectEvent({
      vendor: provider,
      layer,
      index,
    });
    collapsePanel();
  };
  return (
    <div data-test-id="dmb-other-imagery-panel-card">
      {vendors.map((vendor) => (
        <OtherImageryVendor
          activeSubLayerId={activeSubLayerId}
          handleSelectEvent={onSelectEvent}
          key={vendor}
          layers={layers[vendor]}
          locale={locale}
          vendor={vendor}
        />
      ))}
    </div>
  );
}

OtherImageryEvents.propTypes = {
  activeSubLayerId: PropTypes.object.isRequired,
  collapsePanel: PropTypes.func.isRequired,
  handleSelectEvent: PropTypes.func.isRequired,
  layers: PropTypes.object.isRequired,
  locale: PropTypes.string,
  vendors: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default OtherImageryEvents;
